import React from 'react'
import { Paper, IconButton, InputBase } from '@mui/material';


export const PaymentsFilter = ({ useFetchInit }) => {

    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    const { FormFilter } = Forms
    const { formState, onInputChange } = FormFilter
    // ------------------------------------------------ FetchData
    // ------------------------------------------------ Actions
    const { onSubmitFormFilter } = Actions

    return (
        <>
            <Paper
                component="form"
                sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
            >
                <InputBase
                    id="arriendo_registro"
                    name="arriendo_registro"
                    value={formState.arriendo_registro}
                    onChange={onInputChange}
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Identificador de arrendamiento"
                    inputProps={{ 'aria-label': 'Identificador de arrendamiento' }}
                />
                <IconButton
                    type="button" sx={{ p: '10px' }}
                    aria-label="search"
                    onClick={onSubmitFormFilter}
                >
                    <i className="fas fa-search"></i>
                </IconButton>
            </Paper>
        </>
    )
}
